import { makeApiActionCreatorV3 } from '@actions/utils';

import * as api from '../api/dashboard';

const namespace = 'BI';

export const FETCH_USER_ROLES_START = `${namespace}/FETCH_USER_ROLES_START`;
export const FETCH_USER_ROLES_SUCCESS = `${namespace}/FETCH_USER_ROLES_SUCCESS`;
export const FETCH_USER_ROLES_ERROR = `${namespace}/FETCH_USER_ROLES_ERROR`;

export const fetchUserRoles = makeApiActionCreatorV3(
  api.fetchUserRoles,
  FETCH_USER_ROLES_START,
  FETCH_USER_ROLES_SUCCESS,
  FETCH_USER_ROLES_ERROR,
);

export const FETCH_DASHBOARD_USER_ROLES_START = `${namespace}/FETCH_DASHBOARD_USER_ROLES_START`;
export const FETCH_DASHBOARD_USER_ROLES_SUCCESS = `${namespace}/FETCH_DASHBOARD_USER_ROLES_SUCCESS`;
export const FETCH_DASHBOARD_USER_ROLES_ERROR = `${namespace}/FETCH_DASHBOARD_USER_ROLES_ERROR`;

export const fetchDashboardUserRoles = makeApiActionCreatorV3(
  api.fetchDashboardUserRoles,
  FETCH_DASHBOARD_USER_ROLES_START,
  FETCH_DASHBOARD_USER_ROLES_SUCCESS,
  FETCH_DASHBOARD_USER_ROLES_ERROR,
);

export const INSERT_DASHBOARD_USER_ROLE_START = `${namespace}/INSERT_DASHBOARD_USER_ROLE_START`;
export const INSERT_DASHBOARD_USER_ROLE_SUCCESS = `${namespace}/INSERT_DASHBOARD_USER_ROLE_SUCCESS`;
export const INSERT_DASHBOARD_USER_ROLE_ERROR = `${namespace}/INSERT_DASHBOARD_USER_ROLE_ERROR`;

export const insertDashboardUserRole = makeApiActionCreatorV3(
  api.insertDashboardUserRole,
  INSERT_DASHBOARD_USER_ROLE_START,
  INSERT_DASHBOARD_USER_ROLE_SUCCESS,
  INSERT_DASHBOARD_USER_ROLE_ERROR,
);

export const DELETE_DASHBOARD_USER_ROLE_START = `${namespace}/DELETE_DASHBOARD_USER_ROLE_START`;
export const DELETE_DASHBOARD_USER_ROLE_SUCCESS = `${namespace}/DELETE_DASHBOARD_USER_ROLE_SUCCESS`;
export const DELETE_DASHBOARD_USER_ROLE_ERROR = `${namespace}/DELETE_DASHBOARD_USER_ROLE_ERROR`;

export const deleteDashboardUserRole = makeApiActionCreatorV3(
  api.deleteDashboardUserRole,
  DELETE_DASHBOARD_USER_ROLE_START,
  DELETE_DASHBOARD_USER_ROLE_SUCCESS,
  DELETE_DASHBOARD_USER_ROLE_ERROR,
);

export const FETCH_DASHBOARD_CONFIG_START = `${namespace}/FETCH_DASHBOARD_CONFIG_START`;
export const FETCH_DASHBOARD_CONFIG_SUCCESS = `${namespace}/FETCH_DASHBOARD_CONFIG_SUCCESS`;
export const FETCH_DASHBOARD_CONFIG_ERROR = `${namespace}/FETCH_DASHBOARD_CONFIG_ERROR`;

export const fetchDashboardConfig = makeApiActionCreatorV3(
  api.fetchDashboardConfig,
  FETCH_DASHBOARD_CONFIG_START,
  FETCH_DASHBOARD_CONFIG_SUCCESS,
  FETCH_DASHBOARD_CONFIG_ERROR,
);

export const FETCH_DASHBOARD_CONFIGS_START = `${namespace}/FETCH_DASHBOARD_CONFIGS_START`;
export const FETCH_DASHBOARD_CONFIGS_SUCCESS = `${namespace}/FETCH_DASHBOARD_CONFIGS_SUCCESS`;
export const FETCH_DASHBOARD_CONFIGS_ERROR = `${namespace}/FETCH_DASHBOARD_CONFIGS_ERROR`;

export const fetchDashboardConfigs = makeApiActionCreatorV3(
  api.fetchDashboardConfigs,
  FETCH_DASHBOARD_CONFIGS_START,
  FETCH_DASHBOARD_CONFIGS_SUCCESS,
  FETCH_DASHBOARD_CONFIGS_ERROR,
);

export const DELETE_DASHBOARD_CONFIG_START = `${namespace}/DELETE_DASHBOARD_CONFIG_START`;
export const DELETE_DASHBOARD_CONFIG_SUCCESS = `${namespace}/DELETE_DASHBOARD_CONFIG_SUCCESS`;
export const DELETE_DASHBOARD_CONFIG_ERROR = `${namespace}/DELETE_DASHBOARD_CONFIG_ERROR`;

export const deleteDashboardConfig = makeApiActionCreatorV3(
  api.deleteDashboardConfig,
  DELETE_DASHBOARD_CONFIG_START,
  DELETE_DASHBOARD_CONFIG_SUCCESS,
  DELETE_DASHBOARD_CONFIG_ERROR,
);

export const INSERT_DASHBOARD_CONFIG_START = `${namespace}/INSERT_DASHBOARD_CONFIG_START`;
export const INSERT_DASHBOARD_CONFIG_SUCCESS = `${namespace}/INSERT_DASHBOARD_CONFIG_SUCCESS`;
export const INSERT_DASHBOARD_CONFIG_ERROR = `${namespace}/INSERT_DASHBOARD_CONFIG_ERROR`;

export const insertDashboardConfig = makeApiActionCreatorV3(
  api.insertDashboardConfig,
  INSERT_DASHBOARD_CONFIG_START,
  INSERT_DASHBOARD_CONFIG_SUCCESS,
  INSERT_DASHBOARD_CONFIG_ERROR,
);

export const UPDATE_DASHBOARD_CONFIG_START = `${namespace}/UPDATE_DASHBOARD_CONFIG_START`;
export const UPDATE_DASHBOARD_CONFIG_SUCCESS = `${namespace}/UPDATE_DASHBOARD_CONFIG_SUCCESS`;
export const UPDATE_DASHBOARD_CONFIG_ERROR = `${namespace}/UPDATE_DASHBOARD_CONFIG_ERROR`;

export const updateDashboardConfig = makeApiActionCreatorV3(
  api.updateDashboardConfig,
  UPDATE_DASHBOARD_CONFIG_START,
  UPDATE_DASHBOARD_CONFIG_SUCCESS,
  UPDATE_DASHBOARD_CONFIG_ERROR,
);

export const FETCH_DASHBOARD_QUERIES_START = `${namespace}/FETCH_DASHBOARD_QUERIES_START`;
export const FETCH_DASHBOARD_QUERIES_SUCCESS = `${namespace}/FETCH_DASHBOARD_QUERIES_SUCCESS`;
export const FETCH_DASHBOARD_QUERIES_ERROR = `${namespace}/FETCH_DASHBOARD_QUERIES_ERROR`;

export const fetchDashboardQueries = makeApiActionCreatorV3(
  api.fetchDashboardQueries,
  FETCH_DASHBOARD_QUERIES_START,
  FETCH_DASHBOARD_QUERIES_SUCCESS,
  FETCH_DASHBOARD_QUERIES_ERROR,
);

export const FETCH_DASHBOARD_QUERY_START = `${namespace}/FETCH_DASHBOARD_QUERY_START`;
export const FETCH_DASHBOARD_QUERY_SUCCESS = `${namespace}/FETCH_DASHBOARD_QUERY_SUCCESS`;
export const FETCH_DASHBOARD_QUERY_ERROR = `${namespace}/FETCH_DASHBOARD_QUERY_ERROR`;

export const fetchDashboardQuery = makeApiActionCreatorV3(
  api.fetchDashboardQuery,
  FETCH_DASHBOARD_QUERY_START,
  FETCH_DASHBOARD_QUERY_SUCCESS,
  FETCH_DASHBOARD_QUERY_ERROR,
);

export const DELETE_DASHBOARD_QUERY_START = `${namespace}/DELETE_DASHBOARD_QUERY_START`;
export const DELETE_DASHBOARD_QUERY_SUCCESS = `${namespace}/DELETE_DASHBOARD_QUERY_SUCCESS`;
export const DELETE_DASHBOARD_QUERY_ERROR = `${namespace}/DELETE_DASHBOARD_QUERY_ERROR`;

export const deleteDashboardQuery = makeApiActionCreatorV3(
  api.deleteDashboardQuery,
  DELETE_DASHBOARD_QUERY_START,
  DELETE_DASHBOARD_QUERY_SUCCESS,
  DELETE_DASHBOARD_QUERY_ERROR,
);

export const INSERT_DASHBOARD_QUERY_START = `${namespace}/INSERT_DASHBOARD_QUERY_START`;
export const INSERT_DASHBOARD_QUERY_SUCCESS = `${namespace}/INSERT_DASHBOARD_QUERY_SUCCESS`;
export const INSERT_DASHBOARD_QUERY_ERROR = `${namespace}/INSERT_DASHBOARD_QUERY_ERROR`;

export const insertDashboardQuery = makeApiActionCreatorV3(
  api.insertDashboardQuery,
  INSERT_DASHBOARD_QUERY_START,
  INSERT_DASHBOARD_QUERY_SUCCESS,
  INSERT_DASHBOARD_QUERY_ERROR,
);

export const UPDATE_DASHBOARD_QUERY_START = `${namespace}/UPDATE_DASHBOARD_QUERY_START`;
export const UPDATE_DASHBOARD_QUERY_SUCCESS = `${namespace}/UPDATE_DASHBOARD_QUERY_SUCCESS`;
export const UPDATE_DASHBOARD_QUERY_ERROR = `${namespace}/UPDATE_DASHBOARD_QUERY_ERROR`;

export const updateDashboardQuery = makeApiActionCreatorV3(
  api.updateDashboardQuery,
  UPDATE_DASHBOARD_QUERY_START,
  UPDATE_DASHBOARD_QUERY_SUCCESS,
  UPDATE_DASHBOARD_QUERY_ERROR,
);

export const VALIDATE_DASHBOARD_QUERY_START = `${namespace}/VALIDATE_DASHBOARD_QUERY_START`;
export const VALIDATE_DASHBOARD_QUERY_SUCCESS = `${namespace}/VALIDATE_DASHBOARD_QUERY_SUCCESS`;
export const VALIDATE_DASHBOARD_QUERY_ERROR = `${namespace}/VALIDATE_DASHBOARD_QUERY_ERROR`;

export const validateDashboardQuery = makeApiActionCreatorV3(
  api.validateDashboardQuery,
  VALIDATE_DASHBOARD_QUERY_START,
  VALIDATE_DASHBOARD_QUERY_SUCCESS,
  VALIDATE_DASHBOARD_QUERY_ERROR,
);

export const FETCH_DASHBOARD_QUERY_RESULTS_START = `${namespace}/FETCH_DASHBOARD_QUERY_RESULTS_START`;
export const FETCH_DASHBOARD_QUERY_RESULTS_SUCCESS = `${namespace}/FETCH_DASHBOARD_QUERY_RESULTS_SUCCESS`;
export const FETCH_DASHBOARD_QUERY_RESULTS_ERROR = `${namespace}/FETCH_DASHBOARD_QUERY_RESULTS_ERROR`;

export const fetchDashboardQueryResults = makeApiActionCreatorV3(
  api.fetchDashboardQueryResults,
  FETCH_DASHBOARD_QUERY_RESULTS_START,
  FETCH_DASHBOARD_QUERY_RESULTS_SUCCESS,
  FETCH_DASHBOARD_QUERY_RESULTS_ERROR,
);
